const ModalStyles = {
  overlayStyles: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    width: '100%',
    height: '100%',
    zIndex: '12',
    backgroundColor: 'rgba(14, 14, 22, 0.8)',
  },
  dialogStyles: {
    width: '70%',
    height: 'auto',
    position: 'fixed',
    top: '50%',
    left: '50%',
    backgroundColor: '#fff',
    borderRadius: '1.5rem',
    zIndex: '100',
    boxShadow: '0px 0px 4px rgba(0,0,0,.14),0px 4px 8px rgba(0,0,0,.28)',
  },
  headerStyles: {
    backgroundColor: '#29485d',
    padding: '10px 15px',
    color: '#ffffff',
    fontSize: '14px',
    textAlign: 'left',
    borderBottom: 'none',
    borderTopRightRadius: '1.5rem',
    borderTopLeftRadius: '1.5rem',
  },
  bodyStyles: {
    padding: '15px',
    minHeight: '100px',
    color: '#30435D',
  },
  footerStyles: {
    padding: '10px',
    bottom: '0px',
    position: 'absolute',
    width: '99%',
  },
  title: {
    marginTop: '0px',
  },
  closeButtonStyle: {
    cursor: 'pointer',
    fontSize: '1.8em',
  },
};
export default ModalStyles;
